import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator, SelectValidator} from 'react-material-ui-form-validator';
import Moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { setDigitalData } from '../../Utilities/Utils.js';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';


import './Lead.css';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"#FFF" ,
            secondary: "#FFF"
        },
        action: {
            active:"#FFF"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});
const styles = {
    root: {
        color: "#FFF",
        '&$checked': {
            color: "#D52B1E",
        },
    },
    checked: {},
    resize:{
    },
    labelResize:{
    },
    labelSelectResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
	},
    disabled: {},
    focused: {},
    error: {}
}


class DGRLead extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.setValue( 'membership_flow' , true);
        setDigitalData( 'create lead', this.props.DGRStore.club_number );
        //
        //TODO
        //make sure we have product_id, bail otherwise 
        //inside of debug mode check
    }

    handleChange = (e) => {
        this.props.DGRStore.setValue(e.target.name,e.target.value);
    }

    handleSubmit = (e) => {
        // First, make sure they entered a valid birthday.
        var year = this.props.DGRStore.values.year,
            month = ( this.props.DGRStore.values.month + 1 ),
            day = this.props.DGRStore.values.day,
            datestr = '' + year + '-' + ( month < 10 ? '0' : '' ) + month + '-' + ( day < 10 ? '0' : '' ) + day,
            date = Moment( datestr );

        if ( !date.isValid() ) {
            alert('Please enter a valid Date of Birth.');
            e.preventDefault();
            return false;
        }

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Join',
            action: 'Lead Form to Purchase'
        });

       this.props.history.push('sign_waiver');
    }
    render(){
        const { classes } = this.props;
        const { email, first_name, last_name, year, day, month, phone, zipcode, gender  } = this.props.DGRStore.values;
        
        //TODO
        //date stuff that is shared with enterpass.js - refactor to single component, or least utils
        const fillRange = (start, end) => {
            return Array(end - start + 1).fill().map((item, index) => start + index);
        };

        const daysArray = fillRange(1, 31);
        const days = daysArray.map( (day, i ) => {
            return ( 
                <MenuItem 
                    classes={{
                        root: classes.menuItem 
                      }}
                    key={i}
                    value={day}
                 >{day}</MenuItem>
            ); 
        })
        const monthsArray = fillRange(0, 11);
        const months = monthsArray.map( (month, i) => {
            var momentInstance = Moment
            const monthName = momentInstance.months(i)
            return (
                <MenuItem 
                    classes={{
                        root: classes.menuItem 
                      }}
                    key={i} 
                    value={i}
                 >{monthName}</MenuItem>   
            )
        })
        var yearsArray = fillRange( ( new Date().getFullYear() - 100 ), new Date().getFullYear() );
        yearsArray = yearsArray.reverse()
        const years = yearsArray.map( (year, i ) => {
            return ( 
                <MenuItem 
                    classes={{
                        root: classes.menuItem 
                      }}
                    className="year" 
                    key={i} value={year}
                    >{year}
                </MenuItem>
            ); 
        })
        return (
            <div className="lead"> 
                <Fade>
                <MuiThemeProvider theme={theme}>
                <div className="createPassTitleText">
                    <h2>Tell us a bit  more about yourself.</h2>
                </div>
                <div className="createPassTitleSubText">
                    <div className="subText">
                         Photo identification required.  If under 18 years of age, a parent or guardian must be present.
                    </div>
                </div>

             
            <ValidatorForm
                className = "createPassItems"
                ref="form"
                autoComplete="off"
                instantValidate = {false}
                onSubmit={this.handleSubmit}
                onError={errors => console.log(errors)}
            >
                <input autoComplete="off" name="hidden" type="text" style={{display:'none'}}></input>
                <div className="row">
                <TextValidator
                    autoComplete="off"
                    label="First Name"
                    onChange={this.handleChange}
                    name="first_name"
                    value={first_name}
                    validators={['required','matchRegexp:^([^0-9]*)$']}
                    errorMessages={['This field is required', 'No numbers allowed']}
                    className="fname"
                    placeholder="eg: John"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                <TextValidator
                    autoComplete="off"
                    label="Last Name"
                    onChange={this.handleChange}
                    name="last_name"
                    className="lname"
                    value={last_name}
                    validators={['required','matchRegexp:^([^0-9]*)$']}
                    errorMessages={['This field is required', 'No numbers allowed']}
                    placeholder="eg: Smith"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                <SelectValidator
                    className="gender"
                    label="Gender"
                    name="gender"
                    value={gender}
                    onChange={this.handleChange}
                    InputProps={{
                        name: 'gender',
                        id: 'gender',
                        classes: {
                            underline: classes.underline
                        }
                    }}
                    validators={['required']}
                    errorMessages={['This field is required' ]}
                >
                    <MenuItem 
                        classes={{
                            root: classes.menuItem 
                          }}
                        value="f">Female</MenuItem>
                    <MenuItem 
                        classes={{
                            root: classes.menuItem 
                          }}
                        value="m">Male</MenuItem>
                    <MenuItem 
                        classes={{
                            root: classes.menuItem 
                          }}
                        value="u">Unspecified</MenuItem>
                </SelectValidator> 
                </div>
                <div className="row">
                <TextValidator
                    label="Email"
                    autoComplete="off"
                    onChange={this.handleChange}
                    name="email"
                    className="email"
                    value={email}
                    validators={['required', 'isEmail']}
                    errorMessages={['This field is required', 'email is not valid']}
                    placeholder="eg: name@domain.com"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />

                <TextValidator
                    label="Phone"
                    autoComplete="off"
                    onChange={this.handleChange}
                    name="phone"
                    className="phone"
                    value={phone}
                    validators={['required','matchRegexp:^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$']}
                    errorMessages={['This field is required', 'Enter a valid 10-digit phone number' ]}
                    placeholder="eg: 123-456-3828"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                <TextValidator
                    label="Zip"
                    autoComplete="off"
                    onChange={this.handleChange}
                    name="zipcode"
                    className="zipcode"
                    value={zipcode}
                    validators={['required','matchRegexp:^[0-9]{5}(-[0-9]{4})?$']}
                    errorMessages={['This field is required', 'Enter a valid US zipcode'  ]}
                    placeholder="eg: 12345"
                    InputProps={{
                        classes: {
                            input: classes.resize,
                            underline: classes.underline
                        },
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelResize,
                        },
                    }}
                />
                </div>
                <div className="row">
                <div className='birthLabel' >Date of Birth</div>
                <SelectValidator
                    name="year"
                    className="birthYear"
                    value={year}
                    onChange={this.handleChange}
                    InputProps={{
                        classes: {
                            underline: classes.underline
                        },
                        name: 'year',
                        id: 'year',
                    }}
                >
                    {years}
                </SelectValidator> 
                <SelectValidator
                    name="month"
                    className="birthMonth"
                    value={month}
                    onChange={this.handleChange}
                    InputProps={{
                        classes: {
                            underline: classes.underline
                        },
                        name: 'month',
                        id: 'month',
                    }}
                >
                    {months}
                </SelectValidator> 
                <SelectValidator
                    name="day"
                    className="birthDay"
                    value={day}
                    onChange={this.handleChange}
                    InputProps={{
                        classes: {
                            underline: classes.underline
                        },
                        name: 'day',
                        id: 'day',
                    }}
                >
                    {days}
                </SelectValidator> 
                </div>

                <div className="submitCreatePass">
                    <button className="bigButton" type="submit">Next</button>
                </div>
            </ValidatorForm>
             </MuiThemeProvider>
            </Fade>
            </div>
        )
    }
}
        
DGRLead = inject('DGRStore','DGRModalStore', 'DGRBackgroundStore')(observer(DGRLead ))     
//export default DGRCreatePass ;
export default withStyles(styles)(DGRLead);







// WEBPACK FOOTER //
// ./src/components/DGR/Lead/Lead.js